export default "__VITE_ASSET__3bfd037b__"